module.exports = __webpack_public_path__ + "img/brochure-banner.6f395e8f.png";